export class ValidationState {
    errorMessage: string = "";
    hasValidated: boolean = false;

    constructor(errorMessage: string = "", hasValidated: boolean = false) {
        this.errorMessage = errorMessage;
        this.hasValidated = hasValidated;        
    }
}